import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';
import { SnackbarService } from 'vue3-snackbar';
import 'vue3-snackbar/styles';

import '@/assets/styles/css/index.css';
import { i18n } from '@/assets/translations';
import '@/assets/translations/yup';

import App from '@/App.vue';
import { router } from '@/router';

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);
app.use(SnackbarService);
app.use(i18n);
app.mount('#app');
